/** @format */

export const LeadTypes = {
  SELL: 'SELL',
  BUY: 'BUY',
  FREE_VALUATION: 'FREE_VALUATION',
  OTHER: 'OTHER'
};

export const FormSubmitStates = {
  INITIAL: 'INITIAL',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL'
};

export const LeadSources = {
  FM_HOME: 'fm_home',
  FM_LEAD_GEN_PAGE: 'fm_lead_gen_page',
  FM_BUY: 'fm_buy',
  FM_SELL: 'fm_sell',
  FM_EVALUATE: 'fm_evaluate',
  FM_BROKER_PROFILE: 'fm_broker_profile',
  FM_OBJECT_PROFILE: 'fm_object_profile',
  FM_READY_TO_VIEW: 'fm_visningsklar',
  FM_RENOVATION: 'fm_renovation',
  FM_INVEST: 'fm_invest',
  FM_MONITOR: 'fm_monitor',
  FM_RENOVATE: 'fm_renovate',
  FM_BUILD_PROPERTY: 'fm_build_property',
  FM_LEAD_SERVICE_V2: 'fm_lead_service_v2'
};

export const leadUrgency = {
  URGENT: 'urgent',
  NOT_URGENT: 'not_urgent'
};

export const leadBrokerStatuses = {
  HAVE_BROKER: 'have_broker',
  WANT_BROKER_OFFERS: 'want_broker_offers'
};
